export const SUPPORTED_LOCALES = ['et', 'en', 'ru', 'ua'] as const;
export type Locale = typeof SUPPORTED_LOCALES[number];

function toSupportedLocale(value: string): Locale | null {
  const normalized = value.toLowerCase() === 'uk' ? 'ua' : value.toLowerCase();
  return (SUPPORTED_LOCALES as readonly string[]).includes(normalized)
    ? (normalized as Locale)
    : null;
}

export function detectDefaultLocale(): Locale {
  try {
    const stored = localStorage.getItem('i18nextLng') || '';
    const cand = toSupportedLocale(stored.split('-')[0] || '');
    if (cand) return cand;
  } catch {}
  const nav = toSupportedLocale((navigator.language || 'et').split('-')[0]);
  return nav || 'et';
}

export function getLocaleFromPath(pathname: string): Locale {
  const parts = pathname.split('/').filter(Boolean);
  return toSupportedLocale(parts[0] || '') || 'et';
}

export function swapLocaleInPath(pathname: string, newLocale: Locale): string {
  const parts = pathname.split('/').filter(Boolean);
  if (parts.length === 0) return `/${newLocale}/`;
  if (toSupportedLocale(parts[0] || '')) {
    parts[0] = newLocale;
  } else {
    parts.unshift(newLocale);
  }
  const suffixSlash = pathname.endsWith('/') ? '/' : '';
  return '/' + parts.join('/') + suffixSlash;
}

export function readModalParams(sp: URLSearchParams): { date?: string; article?: string } {
  const date = sp.get('date') || undefined;
  const article = sp.get('article') || undefined;
  return { date, article };
}
